import { groupBy } from 'lodash';
import { Edge, MarkerType } from 'reactflow';

import { Prompt, PromptInput } from '../../../../../../services/backendService/types';
import {
  isCuripodPromptInputElement,
  parseStringToSlateObject,
} from '../../../../../SlideComponents/slateUtil';

type GeneratePromptInputToPromptEdgesProps = {
  promptInputs: PromptInput[];
  prompts: Prompt[];
};
const generatePromptInputToPromptEdges = ({
  promptInputs,
  prompts,
}: GeneratePromptInputToPromptEdgesProps) => {
  const edges: Edge[] = [];

  for (const eachPrompt of prompts) {
    const promptIncomingEdges: Edge[] = [];
    for (const eachPromptMessage of eachPrompt.messages) {
      const slateObject = parseStringToSlateObject(eachPromptMessage.content);
      for (const eachElement of slateObject) {
        for (const eachElementChild of eachElement.children) {
          if (isCuripodPromptInputElement(eachElementChild)) {
            promptIncomingEdges.push({
              id: `${eachElementChild.inputId}-${eachPrompt.id}`,
              source: eachElementChild.inputId,
              target: `${eachPrompt.id}`,
              markerEnd: {
                type: MarkerType.ArrowClosed,
              },
            });
          }
        }
      }
    }

    //The edge label should show a label with the number of edges that are coming from the same source into the same target. We reduce it to a single edge with a label.
    const groupedByInput = groupBy(promptIncomingEdges, 'source');
    for (const [_, value] of Object.entries(groupedByInput)) {
      edges.push({
        ...value[0],
        label: value.length,
      });
    }
  }

  return edges;
};

export default generatePromptInputToPromptEdges;
